import { DestroyRef, inject, Injectable } from '@angular/core';
import { map, tap } from 'rxjs';
import { NavigationEnd } from '@angular/router';
import { injectNavigationEnd } from 'ngxtension/navigation-end';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AnalyticsPageViewProvider } from '../providers/page-view-provider';

@Injectable({
  providedIn: 'root',
})
export class NavigationHandlerService {
  private readonly navigationEnd$ = injectNavigationEnd();
  private readonly destroyRef = inject(DestroyRef);
  private readonly pageViewProvider = inject(AnalyticsPageViewProvider);

  public handle(): void {
    this.navigationEnd$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((ev: NavigationEnd) => {
          const url = ev.urlAfterRedirects;
          // Remove possible query parameters and fragments from the URL
          const [path] = url.split(/[?#]/);
          return path;
        }),
        tap((path) => {
          this.pageViewProvider.createAndPush(path);
        }),
      )
      .subscribe();
  }
}
